import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string } from 'prop-types'

import modelSmallImage from 'images/discover/business_account/3d-model-500.webp'
import modelImage from 'images/discover/business_account/3d-model.avif'

import { FORM_ANCHOR_ID } from '../../constants'

function Cta({ cta }) {
  return (
    <section className="business-account-cta">
      <div className="discover-container business-account-cta__wrap">
        <div className="business-account-cta__content">
          <h2 className="discover-heading cgt-heading-400">{cta.title}</h2>
          <Button type="primary" size="large" href={`#${FORM_ANCHOR_ID}`} customClass="business-account-cta__button">
            {cta.button}
          </Button>
        </div>
        <img
          src={modelImage}
          srcSet={`${modelSmallImage} 500w, ${modelImage} 1218w`}
          sizes="(max-width: 639px) 100vw, 610px"
          alt={cta.imageAlt}
          width={1218}
          height={742}
          loading="lazy"
          className="business-account-cta__image"
        />
      </div>
    </section>
  )
}

Cta.propTypes = {
  cta: shape({
    title: string.isRequired,
    button: string.isRequired,
    imageAlt: string.isRequired,
  }).isRequired,
}

export default Cta
